/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import { property as s } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/accessorSupport/ensureType.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import { subclass as t } from "../../../core/accessorSupport/decorators/subclass.js";
import a from "../../Widget.js";
import { css as r, legend as i } from "./ClassicCSS.js";
import { renderRelationshipRamp as l } from "./support/relationshipUtils.js";
import { getUnivariateAboveAndBelowRampElements as o, getUnivariateColorRampSize as n, getUnivariateColorRampPreview as p, getUnivariateColorRampMargin as d, getUnivariateColorSizeRampElements as c } from "./support/univariateUtils.js";
import { getTitle as m, isRendererTitle as y, attachToNode as v, getStretchStopLabel as h, isImageryStretchedLegend as g } from "../support/styleUtils.js";
import { globalCss as u } from "../../support/globalCss.js";
import { Heading as b } from "../../support/Heading.js";
import "../../support/widgetUtils.js";
import { messageBundle as f } from "../../support/decorators/messageBundle.js";
import { tsx as L } from "../../support/jsxFactory.js";
const w = `${i}__`,
  C = 24,
  R = {
    display: "flex",
    alignItems: "flex-start"
  },
  A = {
    marginLeft: "3px"
  },
  _ = {
    display: "table-cell",
    verticalAlign: "middle"
  };
let j = class extends a {
  constructor(e, s) {
    super(e, s), this.activeLayerInfos = null, this.headingLevel = 3, this.messages = null, this.type = "classic";
  }
  render() {
    const e = this.activeLayerInfos,
      s = e && e.toArray().map(e => this._renderLegendForLayer(e)).filter(e => !!e);
    return L("div", null, s && s.length ? s : L("div", {
      class: r.message
    }, this.messages.noLegend));
  }
  _renderLegendForLayer(e) {
    if (!e.ready) return null;
    const s = !!e.children.length,
      t = `${w}${e.layer.uid}-version-${e.version}`,
      a = e.title ? b({
        level: this.headingLevel,
        class: this.classes(u.heading, r.label)
      }, e.title) : null;
    if (s) {
      const s = e.children.map(e => this._renderLegendForLayer(e)).toArray();
      return L("div", {
        class: this.classes(r.service, r.groupLayer),
        key: t
      }, a, s);
    }
    {
      const s = e.legendElements;
      if (s && !s.length) return null;
      const i = s.map(s => this._renderLegendForElement(s, e.layer, e.effectList)).filter(e => !!e);
      if (!i.length) return null;
      const l = {
        [r.groupLayerChild]: !!e.parent
      };
      return L("div", {
        class: this.classes(r.service, l),
        key: t
      }, a, L("div", {
        class: r.layer
      }, i));
    }
  }
  _renderLegendForElement(e, s, t, a) {
    const i = "color-ramp" === e.type,
      o = "opacity-ramp" === e.type,
      n = "size-ramp" === e.type;
    let p = null;
    if ("symbol-table" === e.type || n) {
      const a = e.infos.map(a => this._renderLegendForElementInfo(a, s, t, n, e.legendType)).filter(e => !!e);
      a.length && (p = L("div", {
        class: r.layerBody
      }, a));
    } else "color-ramp" === e.type || "opacity-ramp" === e.type || "heatmap-ramp" === e.type || "stretch-ramp" === e.type ? p = this._renderLegendForRamp(e, s.opacity) : "relationship-ramp" === e.type ? p = l(e, this.id, {
      opacity: s.opacity,
      effectList: t,
      ariaLabel: this.messages.previewRelationshipRampAriaLabel
    }) : "pie-chart-ramp" === e.type ? p = this._renderPieChartRamp(e) : "univariate-above-and-below-ramp" === e.type ? p = this._renderUnivariateAboveAndBelowRamp(e, s.opacity, t) : "univariate-color-size-ramp" === e.type && (p = this._renderUnivariateColorSizeRamp(e, s.opacity, t));
    if (!p) return null;
    const d = e.title;
    let c = null;
    if ("string" == typeof d) c = d;else if (d) {
      const e = m(this.messages, d, i || o);
      c = y(d, i || o) && d.title ? `${d.title} (${e})` : e;
    }
    const v = a ? r.layerChildTable : r.layerTable,
      h = c ? L("div", {
        class: r.layerCaption
      }, c) : null,
      g = {
        [r.layerTableSizeRamp]: n || !a
      };
    return L("div", {
      class: this.classes(v, g)
    }, h, p);
  }
  _renderPieChartRamp(e) {
    return L("div", {
      afterCreate: v,
      bind: e.preview
    });
  }
  _renderUnivariateAboveAndBelowRamp(e, s, t) {
    const {
      sizeRampElement: a,
      colorRampElement: i
    } = o(e, s);
    if (!a) return null;
    const l = this.messages?.previewColorRampAriaLabel,
      c = n(a, "above", !0),
      m = n(a, "below", !0),
      y = 12,
      h = p(i, {
        width: y,
        height: c,
        rampAlignment: "vertical",
        opacity: s,
        type: "above",
        effectList: t,
        ariaLabel: l
      }),
      g = p(i, {
        width: y,
        height: m,
        rampAlignment: "vertical",
        opacity: s,
        type: "below",
        effectList: t,
        ariaLabel: l
      }),
      u = d(a),
      b = a.infos.map(e => e.label),
      f = b.map((e, s) => {
        const t = 2 === s;
        return 0 === s ? L("div", {
          class: e ? h ? r.univariateAboveAndBelowLabel : r.rampLabel : void 0,
          key: s
        }, e) : t ? L("div", null) : null;
      }),
      w = b.length - 1,
      C = Math.floor(b.length / 2),
      j = b.map((e, s) => s === C || s === w ? L("div", {
        class: e ? h ? r.univariateAboveAndBelowLabel : r.rampLabel : void 0,
        key: s
      }, e) : null),
      $ = {
        display: "table-cell",
        verticalAlign: "middle"
      },
      I = {
        marginTop: `${u}px`
      },
      x = {
        height: `${c}px`
      },
      S = {
        height: `${m}px`
      };
    return L("div", {
      key: "univariate-above-and-below-ramp-preview",
      styles: R
    }, L("div", {
      class: r.layerBody
    }, a.infos.map((e, s) => L("div", {
      class: this.classes(r.layerRow, r.sizeRamp)
    }, L("div", {
      afterCreate: v,
      bind: e.preview,
      class: r.symbol,
      styles: $
    }), h || s % 2 != 0 ? null : L("div", {
      class: r.layerInfo
    }, b[s])))), h ? L("div", {
      key: "color-ramp-preview",
      styles: I
    }, L("div", {
      styles: A
    }, L("div", {
      styles: _
    }, L("div", {
      afterCreate: v,
      bind: h,
      class: r.rampContainer
    })), L("div", {
      styles: _
    }, L("div", {
      class: r.rampLabelsContainer,
      styles: x
    }, f))), L("div", {
      styles: A
    }, L("div", {
      styles: _
    }, L("div", {
      afterCreate: v,
      bind: g,
      class: r.rampContainer
    })), L("div", {
      styles: _
    }, L("div", {
      class: r.rampLabelsContainer,
      styles: S
    }, j)))) : null);
  }
  _renderUnivariateColorSizeRamp(e, s, t) {
    const {
      sizeRampElement: a,
      colorRampElement: i
    } = c(e);
    if (!a) return null;
    const l = d(a),
      o = 12,
      m = n(a, "full", !1),
      y = p(i, {
        width: o,
        height: m,
        rampAlignment: "vertical",
        opacity: s,
        type: "full",
        effectList: t,
        ariaLabel: this.messages?.previewColorRampAriaLabel
      }),
      h = a.infos.length - 1,
      g = a.infos.map((e, s) => 0 === s || s === h ? L("div", {
        class: e.label ? i ? r.univariateAboveAndBelowLabel : r.rampLabel : void 0,
        key: s
      }, e.label) : null),
      u = {
        display: "table-cell",
        verticalAlign: "middle"
      },
      b = {
        marginTop: `${l}px`
      },
      f = {
        height: `${m}px`
      };
    return L("div", {
      key: "univariate-above-and-below-ramp-preview",
      styles: R
    }, L("div", {
      class: r.layerBody
    }, a.infos.map(e => L("div", {
      class: this.classes(r.layerRow, r.sizeRamp)
    }, L("div", {
      afterCreate: v,
      bind: e.preview,
      class: r.symbol,
      styles: u
    })))), L("div", {
      key: "color-ramp-preview",
      styles: b
    }, L("div", {
      styles: A
    }, L("div", {
      styles: _
    }, L("div", {
      afterCreate: v,
      bind: y,
      class: r.rampContainer
    })), L("div", {
      styles: _
    }, L("div", {
      class: r.rampLabelsContainer,
      styles: f
    }, g)))));
  }
  _renderLegendForRamp(e, s) {
    const t = e.infos,
      a = "opacity-ramp" === e.type,
      i = "heatmap-ramp" === e.type,
      l = "stretch-ramp" === e.type,
      o = e.preview,
      n = a ? r.opacityRamp : "";
    o.className = `${r.colorRamp} ${n}`, null != s && (o.style.opacity = s.toString());
    const p = t.map(e => L("div", {
        class: e.label ? r.rampLabel : void 0
      }, i ? this.messages[e.label] || e.label : l ? h(e, this.messages) : e.label)),
      d = {
        width: `${C}px`
      },
      c = {
        height: o.style.height
      };
    return L("div", {
      class: r.layerRow
    }, L("div", {
      class: r.symbolContainer,
      styles: d
    }, L("div", {
      afterCreate: v,
      bind: o,
      class: r.rampContainer
    })), L("div", {
      class: r.layerInfo
    }, L("div", {
      class: r.rampLabelsContainer,
      styles: c
    }, p)));
  }
  _renderLegendForElementInfo(e, s, t, a, i) {
    if (e.type) return this._renderLegendForElement(e, s, t, !0);
    let l = null;
    const o = g(s, i);
    if (e.preview ? l = L("div", {
      afterCreate: v,
      bind: e.preview,
      class: r.symbol
    }) : e.src && (l = this._renderImage(e, s, o)), !l) return null;
    const n = {
        [r.imageryLayerInfoStretched]: o
      },
      p = {
        [r.imageryLayerInfoStretched]: o,
        [r.sizeRamp]: !o && a
      };
    return L("div", {
      class: r.layerRow
    }, L("div", {
      class: this.classes(r.symbolContainer, p)
    }, l), L("div", {
      class: this.classes(r.layerInfo, n)
    }, m(this.messages, e.label, !1) || ""));
  }
  _renderImage(e, s, t) {
    const {
        label: a,
        src: i,
        opacity: l
      } = e,
      o = {
        [r.imageryLayerStretchedImage]: t,
        [r.symbol]: !t
      },
      n = {
        opacity: `${null != l ? l : s.opacity}`
      };
    return L("img", {
      alt: m(this.messages, a, !1),
      "aria-label": m(this.messages, a, !1),
      border: 0,
      class: this.classes(o),
      height: e.height,
      src: i,
      styles: n,
      width: e.width
    });
  }
};
e([s()], j.prototype, "activeLayerInfos", void 0), e([s()], j.prototype, "headingLevel", void 0), e([s(), f("esri/widgets/Legend/t9n/Legend")], j.prototype, "messages", void 0), e([s({
  readOnly: !0
})], j.prototype, "type", void 0), j = e([t("esri.widgets.Legend.styles.Classic")], j);
const $ = j;
export { $ as default };